import { useUserAgent } from 'src/common/userAgent/useUserAgent';
import Button from '../button/Button';
import { useWfTyphoonStore } from 'src/api/wf/stores/WfTyphoonStore';
import useWfTyphoonService from 'src/api/wf/service/WfDisasterService';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { wfNavigate } from '../../router/WfScreenRegistration';
import { WF_Screen } from '../../router/WfScreens';
import { WfScreensMap } from '../../router/WfScreensMap';
import { useWfUserStore } from 'src/api/wf/stores/WfUserStore';
import { formatJpnDate } from 'src/common/formatJpnDate/formatJpnDate';

function WF_TyphoonInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userAgent = useUserAgent();
  const { currentTyphoon } = useWfTyphoonStore();
  const { fetchLatestTyphoon } = useWfTyphoonService();
  const { isAdmin } = useWfUserStore();

  const handleLaunchMenu = () => {
    wfNavigate(navigate, WfScreensMap[WF_Screen.SystemLaunch].path);
  };

  useEffect(() => {
    fetchLatestTyphoon();
  }, [fetchLatestTyphoon]);

  const isSystemActive = !!currentTyphoon?.launchDateTime && !currentTyphoon?.shutdownDateTime;

  return (
    <section
      className="rounded-lg border border-blue-400 bg-blue-100 p-4"
      aria-labelledby="typhoon-info-title"
      style={{ position: 'relative' }}
    >
      <h2 id="typhoon-info-title" className="mb-2 text-lg font-bold">
        {t('wf.menu.typhoonMenuTitle')}
      </h2>
      <dl className="space-y-2 text-sm text-gray-700">
        <div className="flex flex-col">
          <span
            style={{ position: 'absolute', top: '1.25rem', right: '1rem' }}
            className={
              isSystemActive
                ? 'rounded bg-red-900 px-1.5 py-0.5 text-xs font-bold text-white'
                : 'rounded bg-gray-100 px-1.5 py-0.5 text-xs font-bold text-gray-400'
            }
          >
            {isSystemActive ? t('wf.menu.systemActive') : t('wf.menu.systemInactive')}
          </span>
        </div>
        <div className="flex flex-col">
          <dt className="font-semibold">{t('wf.menu.typhoonName')}</dt>
          <dd className="break-all ps-2">{currentTyphoon?.name ?? ''}</dd>
        </div>
        <div className="flex flex-col">
          <dt className="font-semibold">{t('wf.menu.systemLaunchDateTime')}</dt>
          <dd className="ps-2">
            {isSystemActive && currentTyphoon.launchDateTime
              ? formatJpnDate({ tsSeconds: currentTyphoon.launchDateTime })
              : ''}
          </dd>
        </div>
        <div className="flex flex-col">
          <dt className="font-semibold">{t('wf.menu.lastUpdated')}</dt>
          <dd className="ps-2">
            {currentTyphoon?.lastImportDateTime
              ? formatJpnDate({ tsSeconds: currentTyphoon.lastImportDateTime })
              : ''}
          </dd>
        </div>
      </dl>
      {userAgent.isDesktop && isAdmin && (
        <div className="mt-4 flex flex-col gap-2">
          <Button title={t('wf.menu.launchMenu')} onClick={handleLaunchMenu} />
        </div>
      )}
    </section>
  );
}

export default WF_TyphoonInfo;
